import axios, { getEnv } from "../../../services/api";
import Axios from "axios";

export const DiagnosticoService = {
    findAll: async (params, body = {}, source) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos/consultar`, body, {
                params,
                cancelToken: source?.token
            });
            return response.data;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada', error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    
    find: async (id) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos/${id}/questionarios`)
            return response.data;
        } catch (error) {
            return error;
        }
    },
    
    save: async (body) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos`, body);
            return response.data;
        } catch (error) {
            throw error
        }
    },
    
    update: async (body) => {
        return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos/questionarios`, body);
    },
    
    changeStatus: async (id , status) => {
        try {
            return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos/${id}/status/${status}`);
        } catch (error) {
            throw error;
        }
    },
    delete: async (id) => {
        return await axios.delete(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos/${id}`);
        
    },
    
    getFilterOptions: async (opcoes = false) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos/opcoes?consulta=${opcoes}`);
            return response.data
        } catch (error) {
            return error;
        }
    },
    getDiagnosticosSas: async (siglaUF) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos/sas?siglaUF=${siglaUF}`);
            return response.data
        } catch (error) {
            throw error;
        }
    },

    
    getPedants: async (body = {}, source) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/diagnosticos-app/servicos/buscar-pendentes`, body, {
                cancelToken: source?.token
            });
            return response.data;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada', error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
}
